import * as React from "react";
import { theme, ui } from "aaa";

export const JuniorTextButton = ({
    children,
    onClick,
    style,
}: {
    children: React.ReactNode,
    onClick: () => void,
    style?: React.CSSProperties,
}) => {
    const linkColor = ui.isDarkMode ? theme.themeColors.d_blue_100 : theme.themeColors.blue_300;
    return (
        <button
            onClick={onClick}
            style={{
                fontSize: 14,
                fontWeight: 600,
                color: linkColor,
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                padding: 0,
                transition: "all 0.3s",
                ...style,
            }}
        >
            {children}
        </button>
    );
};


// WEBPACK FOOTER //
// ./src/components/gJunior/components/JuniorTextButton.tsx